"use strict";

var _defineProperty = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var replaceTestParams = function replaceTestParams(test, params) {
  var newTest = !Array.isArray(test) ? [test] : test;
  return newTest.map(function (t) {
    var field = t.field;

    if (field) {
      Object.keys(params).forEach(function (paramKey) {
        var regExp = new RegExp("{{".concat(paramKey, "}}"), 'gi');

        if (['beta', 'docId'].includes(paramKey)) {
          field = field.replace(regExp, params[paramKey] || false);
        } else {
          field = field.replace(regExp, params[paramKey]);
        }
      }); // if (params.name) {
      //   field = field.replace(/{{name}}/gi, params.name);
      // }
      // field = field.replace(/{{beta}}/gi, params.beta || false);
      // field = field.replace(/{{docId}}/gi, params.docId || false);
    }

    return _objectSpread(_objectSpread({}, t), {}, {
      field: field
    });
  });
};

exports.default = replaceTestParams;